import { render, staticRenderFns } from "./marcas.vue?vue&type=template&id=25c72595&scoped=true&"
import script from "./marcas.vue?vue&type=script&lang=js&"
export * from "./marcas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c72595",
  null
  
)

export default component.exports